import { Fragment, type FC } from "react";

import type { AnswerSegment } from "./diffAnswers";

interface Props {
  segments: AnswerSegment[];
}

const HighlightedAnswer: FC<Props> = ({ segments }) => {
  if (!segments.length) return <>–</>;

  return (
    <span className="answer-diff">
      {segments.map((segment, index) =>
        segment.changed ? (
          <mark key={index} className="answer-diff__mark">
            {segment.text}
          </mark>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </span>
  );
};

export default HighlightedAnswer;
